// extracted by mini-css-extract-plugin
module.exports = {"tabNav":"OperationalSetupTabs_tabNav__2Idbo","active":"OperationalSetupTabs_active__Qm8RK"};